/**
 * Input Capture — captures current key state for network transmission.
 *
 * Only sends pressed keys (sparse encoding) to minimize bandwidth.
 * Average message: ~20 bytes when 1-2 keys held, ~4 bytes when idle.
 */

import { Input, Keys } from 'bonkjs';
import { ACTION } from '../constants';

/** All game-relevant keys that affect gameplay input (event.code format + ACTION codes). */
const GAME_KEYS = [
    Keys.ArrowLeft, Keys.ArrowRight, Keys.ArrowUp, Keys.ArrowDown,
    ACTION.FIRE, ACTION.CHARGE, ACTION.JUMP, ACTION.SWAP,
    Keys.G,
    Keys.W, Keys.A, Keys.S, Keys.D,
    Keys.Digit1, Keys.Digit2, Keys.Digit3, Keys.Digit4,
    Keys.Space,
];

/**
 * Capture the current pressed state of all game-relevant keys.
 * Returns a sparse record (only pressed keys included).
 */
export function captureKeyState(): Record<string, boolean> {
    const keys: Record<string, boolean> = {};
    for (const key of GAME_KEYS) {
        if (Input.getKey(key)) {
            keys[key] = true;
        }
    }
    return keys;
}

